import { Box, Stack, Typography } from '@mui/material';

import mainGradientImage1 from '../../assets/images/main/main_gradient_image_1.webp';
import mainGradientImage2 from '../../assets/images/main/main_gradient_image_2.webp';
import section3Image from '../../assets/images/main/section3_image.webp';
import transformImage1 from '../../assets/images/main/transformImage1.webp';
import transformImage2 from '../../assets/images/main/transformImage2.webp';
import transformImage3 from '../../assets/images/main/transformImage3.webp';
import transformImage4 from '../../assets/images/main/transformImage4.webp';
import transformImage5 from '../../assets/images/main/transformImage5.webp';
import willGetImage from '../../assets/images/main/will_get_image.webp';
import bg from '../../assets/svg/main/bg.svg';
import useScrollTop from '../../hooks/useScrollTop';
import Footer from './components/Footer';
import GradientSection from './components/GradientSection';
import Header from './components/Header';
import ReviewBadge from './components/ReviewBadge';
import Reviews from './components/Reviews';
import TransformItem from './components/TransformItem';

const transformItems = [
  {
    title: 'See Who’s Watching You Live',
    subtitle: 'Track followers, unfollowers, likes & views in real time',
    image: transformImage1,
  },
  {
    title: 'Data-Driven Tips & Insights',
    subtitle: 'Use data to boost reach and build a loyal audience',
    image: transformImage2,
  },
  {
    title: 'Catch Your Secret Admirers',
    subtitle: 'Find people who engage with you but don’t follow',
    image: transformImage3,
  },
  {
    title: 'Track Performance & Trends',
    subtitle: 'Live analytics to track your growth and performance',
    image: transformImage4,
  },
  {
    title: 'Boost Likes with Smart Insights',
    subtitle: 'Improve engagement and make your content shine',
    image: transformImage5,
  },
];

function Main() {
  useScrollTop();

  const moveToOffers = () => {
    window.open(process.env.REACT_APP_LANDING_QUIZ_REDIRECT_LINK, '_self');
  };

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <img
        src={bg}
        alt="Background"
        style={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100%',
          maxHeight: '423px',
          objectFit: 'cover',
          maxWidth: '430px',
          zIndex: 0,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          maxWidth: '430px',
          margin: 'auto',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Header />
        <GradientSection
          title="Boost Your Instagram in Just 5 Minutes!"
          subtitle={
            <>
              Unlock hidden tricks, boost your reach, and automate your routine — <span>discover the secrets!</span>
            </>
          }
          image={mainGradientImage1}
          buttonText="Let’s Level Up My Instagram!"
          onClick={moveToOffers}
        />
        <Box
          sx={{
            mt: '40px',
            p: '0 20px',
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontWeight: 600,
              fontSize: '24px',
              color: '#232631',
            }}
          >
            What you will get
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontWeight: 400,
              fontSize: '16px',
              color: '#8C8E96',
              m: '5px 0 20px',
            }}
          >
            Pro tools, juicy hacks & custom plans to boost your growth — all in one place
          </Typography>
          <img
            style={{
              width: '100%',
              height: 'auto',
              maxWidth: '343px',
              margin: '0 auto',
              display: 'block',
            }}
            src={willGetImage}
            alt="Main 1"
          />
        </Box>
        <Box
          sx={{
            mt: '40px',
            p: '0 20px',
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontWeight: 600,
              fontSize: '24px',
              color: '#232631',
            }}
          >
            Transform Insights into Growth & Grow Faster!
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontWeight: 400,
              fontSize: '16px',
              color: '#8C8E96',
              m: '5px 0 20px',
            }}
          >
            See who unfollowed you, who’s checking your profile, visiting your page, and more juicy stats you didn’t
            know you needed
          </Typography>
          <Stack spacing="10px">
            {transformItems.map((item, index) => (
              <TransformItem key={index} title={item.title} subtitle={item.subtitle} image={item.image} />
            ))}
          </Stack>
        </Box>
        <Box
          sx={{
            mt: '40px',
          }}
        >
          <GradientSection
            title="Who’s secretly watching your Instagram?"
            subtitle={
              <>
                Uncover the hidden viewers who check your profile but never engage. See who they are & how to{' '}
                <span>turn them into fans!</span>
              </>
            }
            buttonText="Reveal Them Now!"
            image={mainGradientImage2}
            onClick={moveToOffers}
          />
        </Box>
        <Box
          sx={{
            padding: '40px 20px 0',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontWeight: 600,
              fontSize: '24px',
              color: '#232631',
              textAlign: 'center',
              marginBottom: '20px',
            }}
          >
            Feedback from our users
          </Typography>
          <ReviewBadge />
          <Reviews />
        </Box>
        <Box
          sx={{
            mt: '40px',
          }}
        >
          <img
            style={{
              width: '100%',
              height: 'auto',
              margin: '0 auto',
              display: 'block',
            }}
            src={section3Image}
            alt="Section 3"
          />
          <Box
            sx={{
              mt: '20px',
              p: '0 20px',
              textAlign: 'center',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Avenir Next',
                fontWeight: 600,
                fontSize: '24px',
                color: '#232631',
              }}
            >
              Explode Your Follower Count
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Avenir Next',
                fontWeight: 400,
                fontSize: '16px',
                color: '#8C8E96',
                m: '5px 0 20px',
              }}
            >
              Discover what drives your likes, follows, and viral moments — and use it to grow like never before
            </Typography>
            <button
              style={{
                cursor: 'pointer',
                background: '#256BFD',
                fontSize: '15px',
                color: '#fff',
                fontWeight: 600,
                fontFamily: 'Avenir Next',
                textTransform: 'none',
                height: '52px',
                width: '100%',
                borderRadius: '12px',
                border: 'none',
                WebkitTapHighlightColor: 'transparent',
              }}
              onClick={moveToOffers}
            >
              Start Growing
            </button>
          </Box>
          <Box
            sx={{
              my: '20px',
              px: '20px',
            }}
          >
            <Footer />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Main;
